<template>
  <el-container
    v-shortkey="{
      f1: ['f1'],
      f2: ['f2'],
      f3: ['f3'],
      f4: ['f4'],
      f5: ['f5'],
      f6: ['f6'],
      f7: ['f7'],
      f8: ['f8'],
      f9: ['f9'],
      f10: ['f10'],
      f11: ['f11'],
      f12: ['f12'],
    }"
    :class="classObj"
    class="app-wrapper"
    tabindex="0"
    @shortkey.native="onKeyUpAnyFKey"
  >
    <operator-setup
      v-if="showExtensionSetupModal"
      :initial-step="2"
      floating
      hide-back-button
      hide-steps
      show-cancel-button
      title="Configura tu extensión"
      @cancel="handleCloseExtensionSetupModal"
      @close="handleCloseExtensionSetupModal"
    />
    <Sidebar class="sidebar-container sidebar-container--administration" />

    <el-main class="p-0 main-container">
      <el-header :class="{ 'fixed-header': fixedHeader }" class="p-0" height="50px">
        <Navbar />
      </el-header>

      <AppMain />
    </el-main>

    <ReubicarExpulsarDialog />
    <CanalRadioDialog />
    <GlobalComponents />
    <ServiceProvidersDialog
      :wgId="callWgId"
      :visible="serviceProvidersDialogFlag"
      :data="serviceProvidersData"
      @close="handleCloseServiceProvidersDialog"
    />
  </el-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { AppMain, Navbar, Sidebar } from "@/layout/components";
import ResizeMixin from "@/layout/mixin/ResizeHandler";
import ReubicarExpulsarDialog from "@/components/ReubicarExpulsarDialog/index";
import CanalRadioDialog from "@/components/CanalRadioDialog/index";
import OperatorSetup from "@/components/setup/OperatorSetup";
import GlobalComponents from "@/components/global/GlobalComponents";
import agent from "@/utils/newrelic.js";
import {
  destroy as destroyScheduledEvents,
  register as registerScheduledEvents,
} from "@/events/scheduled";
import { setCustomAttribute } from "@/api/logging";
import moment from "@/utils/moment";
import { VERSION, BUILD_TIMESTAMP } from "@/utils/version";
import ServiceProvidersDialog from "@/components/ServiceProviders/ServiceProvidersDialog.vue";
import { KBO_TAXIS_SERVICE_NAMES, WORKGROUPS_WITH_MULTIPLE_SERVICES } from "@/utils/constants";

export default {
  name: "LayoutIndex",

  components: {
    ServiceProvidersDialog,
    AppMain,
    Navbar,
    Sidebar,
    ReubicarExpulsarDialog,
    CanalRadioDialog,
    OperatorSetup,
    GlobalComponents,
  },

  mixins: [ResizeMixin],

  data() {
    return {
      serviceProvidersData: null,
      serviceProvidersDialogFlag: false,
      callWgId: null,
      handleF2Timeout: null,
    };
  },

  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      showSettings: (state) => state.settings.showSettings,
      fixedHeader: (state) => state.settings.fixedHeader,
    }),
    ...mapGetters(["appVersion"]),
    ...mapGetters("app", [
      "workgroups",
      "selectedWorkgroupsIds",
      "callCenter",
      "showExtensionSetupModal",
    ]),
    ...mapGetters("pbxCalls", ["hasCalls", "isOnCall"]),
    ...mapGetters("operators", ["operator"]),
    ...mapGetters("clientUserRegisterData", ["deskNumber"]),

    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },

  beforeDestroy() {
    destroyScheduledEvents();
  },

  created() {
    agent.setCustomAttribute("callCenterId", String(this.callCenter?.id));
    agent.setCustomAttribute("callCenterName", String(this.callCenter?.name));
    agent.setCustomAttribute("selectedWorkgroupsIds", this.selectedWorkgroupsIds.join(","));
    agent.setCustomAttribute("application.version", VERSION);
    agent.setCustomAttribute("appBuildTime", BUILD_TIMESTAMP);
    agent.setCustomAttribute(
      "appBuildTimeFormatted",
      moment()(BUILD_TIMESTAMP).format("DD/MM/YYYY HH:mm")
    );
    agent.setCustomAttribute("operatorName", this.operator.name);
    agent.setCustomAttribute("operator", this.operator.user);
    agent.setCustomAttribute("operatorRole", this.operator.rolText);
    agent.setCustomAttribute("deskNumber", this.deskNumber);

    setCustomAttribute("callCenterId", String(this.callCenter?.id));
    setCustomAttribute("callCenterName", String(this.callCenter?.name));
    setCustomAttribute("selectedWorkgroupsIds", this.selectedWorkgroupsIds.join(","));
    setCustomAttribute("application.version", VERSION);
    setCustomAttribute("appBuildTime", BUILD_TIMESTAMP);
    setCustomAttribute(
      "appBuildTimeFormatted",
      moment()(BUILD_TIMESTAMP).format("DD/MM/YYYY HH:mm")
    );
    setCustomAttribute("operatorName", this.operator?.name);
    setCustomAttribute("operator", this.operator?.user);
    setCustomAttribute("operatorRole", this.operator?.rolText);
    setCustomAttribute("deskNumber", this.deskNumber);

    setTimeout(() => {
      registerScheduledEvents();
    }, 1);
  },

  methods: {
    ...mapActions("pbxCalls", ["answerLastCall"]),
    ...mapActions("app", ["setShowExtensionSetupModal"]),
    ...mapActions("clientUserRegisterData", ["getPhoneExt"]),

    handleCloseServiceProvidersDialog() {
      this.serviceProvidersData = null;
      this.serviceProvidersDialogFlag = false;
    },

    handleCloseExtensionSetupModal() {
      this.setShowExtensionSetupModal(false);
    },

    async handleF3() {
      const paramId = new Date().getTime();
      this.$router.push({
        path: "/services/create/" + paramId,
      });
    },

    async handleF2() {
      clearTimeout(this.handleF2Timeout);
      if (this.isOnCall) {
        this.handleF2Timeout = setTimeout(this.handleF2, 100);
        return;
      }

      if (this.hasCalls) {
        const phoneExt = await this.getPhoneExt();
        if (!phoneExt) return;

        const data = await this.answerLastCall();
        if (data && data.asteriskId) {
          const paramId = new Date().getTime();
          if (
            !WORKGROUPS_WITH_MULTIPLE_SERVICES.includes(data.wgId) ||
            !data.serviceProvided ||
            KBO_TAXIS_SERVICE_NAMES.includes(data.serviceProvided)
          ) {
            await this.$router.push({
              path: "/services/create/" + paramId,
              query: {
                callerNumber: data.callerNumber,
                asteriskId: data.asteriskId,
                wgId: data.wgId,
              },
            });
          } else {
            this.callWgId = data.wgId;
            this.serviceProvidersData = data;
            this.serviceProvidersDialogFlag = true;
          }
        }
      }
    },

    async onKeyUpAnyFKey(ev) {
      switch (ev.srcKey) {
        case "f2":
          await this.handleF2();
          break;
        case "f3":
          await this.handleF3();
          break;
        case "f6":
          this.$store.commit("canalRadioDialog/setShow", true);
          break;
        case "f9":
          await this.$store.dispatch("reubicarExpulsar/showDialog", {
            show: true,
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
